import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useOptimisticRemove } from "@/hooks/useOptimisticRemove";
import { deletePursuit } from "@/features/pursuit/api/apiPursuit";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Ellipsis, Eye, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

export default function PursuitOperations({
  pursuit,
  renderDropDownMenuTrigger,
}) {
  const removeFilterFn = (p) => {
    return p.id !== pursuit.id;
  };
  const { mutate: removePursuit, isLoading: isRemoving } = useOptimisticRemove(
    ["user-pursuits"],
    deletePursuit,
    removeFilterFn
  );
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return (
    <AlertDialog>
      <DropdownMenu>
        {renderDropDownMenuTrigger ? (
          renderDropDownMenuTrigger()
        ) : (
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              onClick={(e) => e.stopPropagation()} // Prevents onClick from bubbling
            >
              <Ellipsis className="" />
            </Button>
          </DropdownMenuTrigger>
        )}
        <DropdownMenuContent>
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              navigate(
                `/contract/${pursuit.search_type}/${pursuit.proposal_id}`
              );
            }}
            disabled={pursuit?.search_type === "upload"}
          >
            <Eye className="mr-2 h-4 w-4" />
            View
          </DropdownMenuItem>
          <AlertDialogTrigger
            className="w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <DropdownMenuItem disabled={isRemoving}>
              <Trash2 className="mr-2 h-4 w-4 text-destructive" />
              Delete
            </DropdownMenuItem>
          </AlertDialogTrigger>
        </DropdownMenuContent>
      </DropdownMenu>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone and will permanently delete your
            pursuit and all its tasks.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={(e) => e.stopPropagation()}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            variant={"destructive"}
            onClick={(e) => {
              e.stopPropagation();
              removePursuit(pursuit.id, {
                onSuccess: () => {
                  if (pursuit.search_type !== "upload") {
                    queryClient.invalidateQueries([
                      "contract",
                      pursuit.search_type,
                      pursuit.proposal_id,
                    ]);
                  }
                  navigate("/journey-hub");
                },
              });
            }}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
